import React from 'react';
import './testimonials.css'

const Testimonials = () => {
    return (
      <section id='tes'></section>
    );
};

export default Testimonials;